import { GenericObject, copyFields, fixDates } from '@synergy/models';

import { Contact } from '../../../../common/models/contact';
import { Supplier } from '../../../../common/models/supplier';

export class ImportSupplier {
    public id!: number;
    public status!: ImportSupplierStatus;
    public supplier!: Supplier;
    public lastImport!: Date;
    public lastPriceAdjustment!: Date;

    public importIntervalType!: ImportIntervalType;
    public time!: Date;
    public weekday!: number;
    public dayOfMonth!: number;
    public month!: number;

    public importReceptionType!: ImportReceptionType;
    public internalNote!: string;
    public importContact!: Contact;

    public static fromPlainObject(object: GenericObject): ImportSupplier {
        const job = new ImportSupplier();

        copyFields(object, job);

        if (object['supplier']) {
            job.supplier = Supplier.fromPlainObject(object['supplier']);
        }

        if (object['supplier']['importContact']) {
            job.importContact = Contact.fromPlainObject(object['supplier']['importContact']);
        }

        fixDates(job, ['lastImport', 'lastPriceAdjustment']);

        return job;
    }
}

export interface ImportSupplierRequest {
    supplierAccountId: number;
    importIntervalType: ImportIntervalType;
    importReceptionType: ImportReceptionType;
    time?: Date | string;
    weekday?: number;
    dayOfMonth?: number;
    month?: number;
    internalNote?: string;
}

export enum ImportIntervalType {
    Daily = 'DAILY',
    Weekly = 'WEEKLY',
    EveryTwoWeeks = 'EVERY_TWO_WEEKS',
    Monthly = 'MONTHLY',
    Yearly = 'YEARLY',
}

export enum ImportReceptionType {
    Email = 'EMAIL',
    Ftp = 'FTP',
    Sftp = 'SFTP',
    SftpFetch = 'SFTP_FETCH',
}

export enum ImportSupplierStatus {
    NoInterval = 'STATUS_NO_INTERVAL',
    OnSchedule = 'STATUS_ON_SCHEDULE',
    Overdue = 'STATUS_OVERDUE',
}
